<script lang="ts">
  import { resolve } from "$app/paths";
  import { t } from "$lib/i18n";

  // The React app's two error screens, NotFound and ErrorPage (see showsNotFound).
  let { notFound }: { notFound: boolean } = $props();
</script>

{#if notFound}
  <div class="h-screen flex flex-col items-center justify-center text-white text-lg">
    <h1 class="text-xl">{t("system.not_found")}</h1>
    <a class="mt-4" href={resolve("/")}>{t("generic.try")} app.dockethealth.com?</a>
    <img class="rounded-box" src="/assets/images/error.png" alt="" />
  </div>
{:else}
  <div
    id="error-page"
    data-testid="static-error-page"
    class="flex items-center justify-center h-screen bg-[url(/assets/images/error_centered.png)] bg-cover bg-center bg-no-repeat"
  >
    <div class="text-center text-lg mt-42 w-64 max-w-screen rounded-box">
      <p>Docket wasn't immunized against this unknown error.</p>
      <p class="mt-2">Please refresh the page or restart the app.</p>
    </div>
  </div>
{/if}
